<template>
  <div class="page">
    <div class="head-warp">
      <div class="title">诚信合作，创新共享</div>
      <div class="description">赢科天地专注于中国教育行业信息化建设十余年，不断创新技术应用模式，成为引领高等院校信息化建设的高科技企业。</div>
      <div class="eng">Informatization<br>Normalization<br>Creativity<br>Optimization</div>
    </div>
    <div v-if="url.endsWith('.pdf')" style="margin: 0 auto; width: 65%;">
      <!-- loading提示 -->
      <div v-if="isLoading" style="padding:30px;text-align:center">
        PDF加载中 {{ progressPercent }}%
      </div>
      <div v-if="pdfError" style="color:red;text-align:center">
        PDF加载失败
      </div>
      <!-- 所有PDF页面 -->
      <template v-if="numPages && !isLoading && !pdfError">
        <pdf
          v-for="page in numPages"
          :key="page"
          :src="loadingTask"
          :page="page"
          style="margin-bottom:10px"
        />
      </template>
    </div>
    <div v-else style="margin: 0 auto; width: 65%;">
      <img width="100%" :src="url" alt="">
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: { pdf },
  name: 'ProductionFive',
  data() {
    return {
      url: "",
      loadingTask: null,
      numPages: 0,
      isLoading: false,
      pdfError: false,
      progressPercent: 0
    }
  },
  methods: {
    resolveImg(img) {
      if (img && typeof img === 'string') {
        const at = img.match(/^@\/assets\/(.+)$/)
        if (at) {
          return require('../assets/' + at[1])
        }
      }
      return img || ''
    },
    loadPdf() {
      if (!this.url) return
      // 重置状态
      this.isLoading = true
      this.pdfError = false
      this.numPages = 0
      this.progressPercent = 0

      this.loadingTask = pdf.createLoadingTask(this.url)

      // 原生监听下载进度（最稳定，推荐！）
      this.loadingTask.onProgress = (status) => {
        const percent = (status.loaded / status.total * 100).toFixed(0)
        this.progressPercent = percent
      }

      this.loadingTask.promise.then(pdfDoc => {
        this.numPages = pdfDoc.numPages
        this.isLoading = false
      }).catch(err => {
        console.error('PDF异常', err)
        this.pdfError = true
        this.isLoading = false
      })
    }
  },
  mounted() {
    this.url = this.resolveImg(this.$route.query.filePath)
    this.loadPdf()
  },
  beforeDestroy() {
    if (this.loadingTask) {
      this.loadingTask.destroy()
    }
  }
}
</script>

<style scoped lang="less">
.page {
  .head-warp {
    min-width: 1200px;
    padding: 20px 80px;
    text-align: left;
    background-image: url('../assets/zpqs.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .title {
      font-size: 18px;
      font-weight: 600;
    }
    .description {
      width: 320px;
      font-size: 16px;
    }
    .eng {
      position: absolute;
      top: 19px;
      right: 80px;
      font-weight: 800;
      font-size: 25px;
      line-height: 1.7rem;
    }
  }
  .contain {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 50px;
    .title {
      line-height: 50px;
      font-size: 17px;
      font-weight: 700;
    }
    .des {
      padding-bottom: 10px;
    }
    .box {
      .sub {
        display: inline-block;
        width: 30%;
        vertical-align: top;
      }
      .last-sub {
        display: inline-block;
        width: 40%;
        vertical-align: top;
      }
      .title {
        // width: 130px;
        padding-top: 25px;
        line-height: 25px;
        font-size: 16px;
        font-weight: 400;
      }
      .text {
        margin: 25px 0;
        font-size: 15px;
        & /deep/ p {
          margin-bottom: 20px;
          font-size: 15px;
          line-height: 25px;
        }
      }
      .grid {
        .title {
          padding-top: 15px;
          line-height: 20px;
          font-size: 20px;
        }
        .text {
          overflow: hidden;
          display: -webkit-box;
          word-break: break-all;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          margin: 15px 0;
          font-size: 10px;
        }
      }
    }
  }
}
.contain /deep/ .ivu-divider-horizontal {
  margin: 0;
}

.box /deep/ .ivu-card {
  border-radius: 0;
}
.box /deep/ .ivu-card-bordered {
  border: 1px solid #e0e0e0;
  border-color: #e0e0e0;
}
.box /deep/ .ivu-card-body {
  padding: 0 16px 0 16px;
}
</style>
